<template>
  <component class="svg-inline"
             :is="componentFile">
  </component>
</template>

<script>
export default {
  name: 'inline-svg',

  props: {
    src: {
      type: [String],
      default: ''
    }
  },

  computed: {
    componentFile () {
      return this.importComponent(this.src)
    }
  },

  methods: {
    importComponent (path) {
      return () => import(`../icons/${path}.vue`)
    }
  }
}
</script>

<style scoped>
.svg-inline {
  width: 100%;
  height: 100%;
}
</style>
